import type { Signer } from "@ethersproject/abstract-signer"
import { isAddress } from "@ethersproject/address"
import type { Provider } from "@ethersproject/providers"
import type { FetchSignerResult, Signer as WagmiSigner } from "@wagmi/core"
import { OpenZeppelinGovernor__factory as OpenZeppelinGovernorFactory } from "@/contracts/bindings/factories/OpenZeppelinGovernor__factory"
import type { OpenZeppelinGovernor } from "@/contracts/bindings/OpenZeppelinGovernor"

export const getGovernorOpenZeppelin = (
  address: string,
  signerOrProvider:
    | Signer
    | Provider
    | NonNullable<FetchSignerResult<WagmiSigner>>,
): OpenZeppelinGovernor => {
  return OpenZeppelinGovernorFactory.connect(address, signerOrProvider)
}

export const useGovernorOpenZeppelin = (
  address?: string,
  signerOrProvider?: Signer | Provider | FetchSignerResult<WagmiSigner>,
): OpenZeppelinGovernor | undefined => {
  if (!address || !isAddress(address) || !signerOrProvider) return

  return getGovernorOpenZeppelin(address, signerOrProvider)
}
